import { ErrorManagementUnresolvedVendorErrorCodesApi } from '@evimo/client/apis';
import { createApiConfiguration } from '~/app/lib/api-config';

const config = createApiConfiguration();

export const unresolvedVendorErrorCodesApi =
  new ErrorManagementUnresolvedVendorErrorCodesApi(config);

export const unresolvedVendorErrorCodesRequestInit = {
  credentials: 'include' as const,
};
